
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholars",
      function () {
        return require("private-next-pages/scholars.js");
      }
    ]);
  